import { useState, useEffect } from "react";
import marsImg from "../../assets/images/mangal.webp";
import './testimonialsection.css';

const testimonials = [
  {
    text: "The personalised horoscope is so accurate! It made me realise how generic my aaj ka rashifal search results on all other apps and websites were.",
    author: "Nitin Nair, 31, Bangalore",
    avatar: marsImg,
  },
  {
    text: "I used the shubh muhurat feature to schedule an important meeting, and it went perfectly. This is my new secret weapon for planning my week.",
    author: "Riah Hingarh, Mumbai, 25",
    avatar: marsImg,
  },
  {
    text: "Seeing my entire life mapped out astrologically was mind-blowing. It showed my patterns that I didn’t realise existed. Crazy that this is free!",
    author: "Manan Bothra, 44, Bikaner",
    avatar: marsImg,
  },
];

export default function TestimonialSlider() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      handleSlide("next");
    }, 5000); // Auto-slide every 5 seconds

    return () => clearInterval(interval);
  }, [current]); // Re-run effect when current slide changes

  const handleSlide = (direction) => {
    if (animating) return;
    setAnimating(true);

    setTimeout(() => {
      setCurrent((prev) =>
        direction === "next"
          ? (prev + 1) % testimonials.length
          : (prev - 1 + testimonials.length) % testimonials.length
      );
      setAnimating(false);
    }, 300);
  };

  return (
    <div className="relative overflow-hidden">
      <div className="testimonial-mars-img-container">
        <img
          src={marsImg}
          alt="Mars"
          className="testimonial-mars-img"
          loading="lazy"
        />
      
    </div>
    <div className="testimonial-slider">
      {/* Mars Planet */}
      

      {/* Quote Text */}
      <div
        className={`testimonial-quote-text ${animating ? "animating" : ""}`}
      >
        {testimonials[current].text}
      </div>

      {/* Author */}
      <p className="testimonial-author">
        {testimonials[current].author}
      </p>

      {/* Navigation Arrows */}
      <div className="testimonial-nav-arrow-left">
        <button onClick={() => handleSlide("prev")}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#813518"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
      </div>
      <div className="testimonial-nav-arrow-right">
        <button onClick={() => handleSlide("next")}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#813518"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>

      {/* Avatars */}
      {/* <div className="testimonial-avatars-container">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className={`testimonial-avatar-item ${i === current ? "active" : ""}`}
          >
            <img
              src={t.avatar}
              alt={`User ${i}`}
              className="testimonial-avatar-img"
            />
          </div>
        ))}
      </div> */}
      </div>
    </div>
  );
}
